import { entity } from "simpler-state"

// Store the transaction ID to highlight (persists after modal close)
export const AccountingTransactionModalId = entity<string | null>(null)

// Whether the modal is currently open
export const AccountingTransactionModalOpen = entity<boolean>(false)

export function openAccountingTransactionModal(transactionId: string) {
  AccountingTransactionModalId.set(transactionId)
  AccountingTransactionModalOpen.set(true)
}

export function closeAccountingTransactionModal() {
  AccountingTransactionModalOpen.set(false)
  // Don't clear AccountingTransactionModalId - keep it for row highlighting
}

// Helper to close modal before navigating (used by links inside modal content)
export function closeModalAndNavigate(navigate: (url: string) => void, url: string) {
  closeAccountingTransactionModal()
  navigate(url)
}
